export default
{
  CALLED: {
    color: '#7ddb30',
    text: 'oddzwoniono',
  },
  NOT_CALLED: {
    color: '#757575',
    text: 'do oddzwonienia',
  },
  CALLING: {
    color: '#db3030',
    text: 'połączenie obdzwaniane przez innego Agenta',
  },
};
